import { createContext, useContext, useRef } from "react";

export const LoadingContext = createContext({
    loaderRef: null,
});

export function LoadingProvider({ children }) {
    const loaderRef = useRef(null)
    const value = loaderRef

    return (
        <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
    );
}



export function useLoading() {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error("useLoading must be used within LoadingProvider");
    }
    return context;
}